import {
  SIGNIN,
  SIGNIN_OTP,
  AUTHENTICATED,
  SIGNOUT,
  SIGNOUT_SUCCESS,
  SHOW_AUTH_MESSAGE,
  HIDE_AUTH_MESSAGE,
  SHOW_LOADING,
  SIGNIN_WITH_GOOGLE,
  SIGNIN_WITH_GOOGLE_AUTHENTICATED,
  SHOWOTPFORM,
  VICIDIAL_LOGIN,
  VICIDIAL_AUTHENTICATED,
  LOAD_CUSTOMER_LIST,
} from "../constants/Auth";

export const signIn = (user) => {
  return {
    type: SIGNIN,
    payload: user,
  };
};

export const signInOtp = (user) => {
  return {
    type: SIGNIN_OTP,
    payload: user,
  };
};

export const authenticated = (user) => {
  return {
    type: AUTHENTICATED,
    user,
  };
};

export const showOtpForm = (status) => {
  return {
    type: SHOWOTPFORM,
    status,
  };
};

export const signInWithGoogleAuthenticated = (user) => {
  return {
    type: SIGNIN_WITH_GOOGLE_AUTHENTICATED,
    user,
  };
};

export const signOut = (username,vicidialServerIp) => {
  return {
    type: SIGNOUT,
    //payload: {vicidialUserInfo,vicidialServerIp},
    payload: {username,vicidialServerIp},
  };
};

export const signOutSuccess = () => {
  return {
    type: SIGNOUT_SUCCESS,
  };
};

export const signInWithGoogle = (googleData) => {
  return {
    type: SIGNIN_WITH_GOOGLE,
    payload: googleData,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_AUTH_MESSAGE,
    message,
  };
};

export const hideAuthMessage = () => {
  return {
    type: HIDE_AUTH_MESSAGE,
  };
};

export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};

export const vicidialLogin = (userInfo, campaign,vicidialServerIp) => {
  return {
    type: VICIDIAL_LOGIN,
    payload: { userInfo, campaign ,vicidialServerIp},
  };
};
export const vicidialAuthenticated = (viciUserInfo) => {
  return {
    type: VICIDIAL_AUTHENTICATED,
    viciUserInfo,
  };
};
export const loadCustomerList = (customerList) => {
  return {
    type: LOAD_CUSTOMER_LIST,
    customerList,
  };
};

